/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast.  Keeping your custom
 * Javascript in this fill will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  // Add custom code below this line
  var body = document.querySelector("body.template-product");
  if (body) {
    var states = {
      AC: "Acre",
      AL: "Alagoas",
      AP: "Amapá",
      AM: "Amazonas",
      BA: "Bahia",
      CE: "Ceará",
      DF: "Distrito Federal",
      ES: "Espírito Santo",
      GO: "Goiás",
      MA: "Maranhão",
      MT: "Mato Grosso",
      MS: "Mato Grosso do Sul",
      MG: "Minas Gerais",
      PA: "Pará",
      PB: "Paraíba",
      PR: "Paraná",
      PE: "Pernambuco",
      PI: "Piauí",
      RJ: "Rio de Janeiro",
      RN: "Rio Grande do Norte",
      RS: "Rio Grande do Sul",
      RO: "Rondônia",
      RR: "Roraima",
      SC: "Santa Catarina",
      SP: "São Paulo",
      SE: "Sergipe",
      TO: "Tocantins",
    };

    async function getCepData(cep) {
      //const response = await fetch("https://brasilapi.com.br/api/cep/v2/" + cep);
      const response = await fetch(
        "https://viacep.com.br/ws/" + cep + "/json/"
      );
      const data = await response.json();
      return data;
    }

    var showRates = function (rates, city, state, target) {
      //Convert date
      var formatDate = function (input) {
        var datePart = input.match(/\d+/g),
          year = datePart[0].substring(2), // get only two digits
          month = datePart[1],
          day = datePart[2];

        return day + "/" + month + "/" + year;
      };

      console.log(target, "showRates");

      var output = "";
      if (rates === false) {
        if (target == "product") {
          calcError(
            "Nenhum método de entrega encontrado, confira se o CEP informado é válido."
          );
        }

        if (target == "cart") {
          calcCartError(
            "Nenhum método de entrega encontrado, confira se o CEP informado é válido."
          );
        }
      } else {
        var truck_icon =
          '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 21.5"><g data-name="Layer 2"><g data-name="Layer 1"><path d="M7.16 17H6a1 1 0 0 1-1-1v-4a1 1 0 0 0-2 0v4a3 3 0 0 0 3 3h1.2a3.48 3.48 0 0 0 6.68 0h6.32a3.48 3.48 0 0 0 6.68 0H29a1 1 0 0 0 1-1v-5a4.91 4.91 0 0 0-.72-2.39l-2.9-4.33A3.08 3.08 0 0 0 24 5h-2.8V3a3 3 0 0 0-3-3H15a1 1 0 0 0 0 2h3.2a1 1 0 0 1 1 1v14h-5.36a3.48 3.48 0 0 0-6.68 0Zm16.34 2.5A1.5 1.5 0 1 1 25 18a1.5 1.5 0 0 1-1.5 1.5ZM21.2 7H24a1.08 1.08 0 0 1 .72.39L26.47 10H21.2Zm0 5h6.56a3.14 3.14 0 0 1 .24 1v4h-1.16a3.47 3.47 0 0 0-4.31-2.35 3.43 3.43 0 0 0-1.33.74ZM12 18a1.5 1.5 0 1 1-1.5-1.5A1.5 1.5 0 0 1 12 18Z"/><path d="M13 1a1 1 0 0 0-1-1H1a1 1 0 0 0 0 2h11a1 1 0 0 0 1-1Zm-3 5a1 1 0 0 0 0-2H3a1 1 0 0 0 0 2Zm-2 4a1 1 0 0 0 0-2H5a1 1 0 0 0 0 2Z"/></g></g></svg>';
        output +=
          '<div class="heading">' +
          truck_icon +
          " Opções de Frete para " +
          city +
          " - " +
          state +
          "</div>";
        output += '<div class="shipping-rates">';
        output += '<div class="rates">';
        Object.keys(rates).forEach((key) => {
          var rate = rates[key];
          var price = parseFloat(rate.price);
          var delivery = "";
          var dataDelivery = rate.delivery_date;
          var dataDeliveryOld = new Date(dataDelivery);
          var dataDeliveryFormat = dataDeliveryOld.toLocaleDateString("pt-BR", {
            timeZone: "UTC",
          });

          if (price == 0.0) {
            price = "<b>Grátis</b>";
          } else {
            price = price.toLocaleString("pt-br", {
              style: "currency",
              currency: "BRL",
            });
          }

          /* 
          if (rate.presentment_name == "Retire na Loja") {
            delivery =
              '<div class="rate__info"><b>Retire na Loja:</b><span><b> Grátis</b> <b>1 dia</b> útil</span></div>';
          }
          */

          if (rate.presentment_name == "PAC") {
            delivery =
              '<div class="rate__info"><span><b>' +
              rate.presentment_name.replace(" (via Shippy)", "") +
              ": </b></span><span><b>" +
              price +
              "</b> receba em <b>" +
              rate.delivery_days[0] +
              "</b> dias úteis</span></div>";
          } else {
            delivery =
              '<div class="rate__info"><span><b>' +
              rate.presentment_name.replace(" (via Shippy)", "") +
              ": </b></span><span><b>" +
              price +
              "</b> receba em <b>" +
              rate.delivery_days[0] +
              "</b> dias úteis</span></div>";
          }

          var day_min = 1;
          var day_max = 3;

          if (rate.delivery_days[0] != null) {
            day_min = rate.delivery_days[0] - 2;
            day_min = day_min < 1 ? 1 : day_min;
          }

          if (rate.delivery_days[1] != null) {
            day_max = rate.delivery_days[1] + 1;
          }

          output += '<div class="rate">';
          output += delivery;
          output += "</div>";
        });

        output += "</div>";
        output +=
          '<p class="result__information">* A previsão de entrega já contabiliza o prazo de produção + frete.</p>';

        if (target == "cart") {
          output +=
            '<a href="#" class="close-button" title="Fechar cálculo de frete">Fechar</a>';
        }

        output += "</div>";

        if (target == "product") {
          $(".shipping-estimate .result").show().html(output);
        }

        if (target == "cart") {
          $(".cart-shipping-results").addClass("open").html(output);
        }
      }
    };

    var getCookie = function (name) {
      var value = "; " + document.cookie;
      var parts = value.split("; " + name + "=");
      if (parts.length == 2) return parts.pop().split(";").shift();
    };

    var cartCookie = getCookie("cart");

    var updateCartCookie = function (a) {
      var date = new Date();
      date.setTime(date.getTime() + 14 * 86400000);
      var expires = "; expires=" + date.toGMTString();
      document.cookie = "cart=" + a + expires + "; path=/";
    };

    var resetCartCookie = function () {
      updateCartCookie(cartCookie);
      endLoader();
    };

    var startLoader = function (message = "") {
      var loader_icon =
        '<svg version="1.1" id="L5" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 100 100" enable-background="new 0 0 0 0" xml:space="preserve" style="display: inline-block;width: 30px;"><circle fill="#111" stroke="none" cx="6" cy="50" r="6"><animateTransform attributeName="transform" dur="1s" type="translate" values="0 15 ; 0 -15; 0 15" repeatCount="indefinite" begin="0.1"></animateTransform></circle><circle fill="#111" stroke="none" cx="30" cy="50" r="6"><animateTransform attributeName="transform" dur="1s" type="translate" values="0 10 ; 0 -10; 0 10" repeatCount="indefinite" begin="0.2"></animateTransform></circle><circle fill="#111" stroke="none" cx="54" cy="50" r="6"><animateTransform attributeName="transform" dur="1s" type="translate" values="0 5 ; 0 -5; 0 5" repeatCount="indefinite" begin="0.3"></animateTransform></circle></svg>';
      $(".shipping-estimate .loading").html(loader_icon + message);
      $(".shipping-estimate .result").html("");
    };

    var endLoader = function () {
      $(".shipping-estimate .loading").html("");
    };

    var calcError = function (message) {
      $(".shipping-estimate .loading").html("");
      $(".shipping-estimate .result").html(
        '<span class="error">' + message + "</span>"
      );
    };

    var calculateShipping = function () {
      var product_id = $('input[name="id"]').val();
      var cep = $(".cep-estimate").val().replace(/\D/g, "");

      if (cep.length == 8) {
        startLoader("Calculando frete");

        getCepData(cep)
          .then((data) => {
            var country = "Brazil";
            /*
            var state = states[data.state];
            var city = data.city;
          */
            var state = states[data.uf];
            var city = data.localidade;

            var zip = cep;
            var random = (Math.random() + 1).toString(36).substring(10);

            localStorage.setItem("cepCache", zip);

            startLoader("Calculando frete para " + city + " - " + state);

            cartCookie = getCookie("cart");

            var tempCookieValue =
              tempCookieValue || "temp-cart-cookie___" + Date.now() + random;
            var fakeCookieValue =
              fakeCookieValue || "fake-cart-cookie___" + Date.now() + random;

            if (!cartCookie) {
              updateCartCookie(tempCookieValue);
              cartCookie = getCookie("cart");
            }

            if (cartCookie.length < 32) {
              return;
            }

            updateCartCookie(fakeCookieValue);

            getRates(parseInt(product_id), country, state, city, zip);

            return;
          })
          .catch(function () {
            endLoader();
          });
      } else {
        calcError("Por favor, insira um CEP válido.");
      }
    };

    $(".shipping-estimate button").on("click", function (e) {
      e.preventDefault();
      calculateShipping();
    });

    $(".shipping-estimate .cep-estimate").on("keypress", function (e) {
      if (e.which === 13) {
        e.preventDefault();
        calculateShipping();
      }
    });

    var getRates = function (variantId, country, state, city, zip) {
      if (typeof variantId === "undefined") {
        return;
      }

      var productQuantity = $("quantity-input__element");

      var quantity = productQuantity ? parseInt(productQuantity.val()) : 1;

      var addData = {
        id: variantId,
        quantity: quantity,
      };

      var attempts = 0;

      fetch("/cart/add.js", {
        body: JSON.stringify(addData),
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "xmlhttprequest",
        },
        method: "POST",
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (json) {
          $.ajax({
            type: "GET",
            url: "/cart/shipping_rates.json",
            data: {
              "shipping_address[country]": country,
              "shipping_address[province]": state,
              "shipping_address[zip]": zip,
            },
            success: function (d) {
              if (d.shipping_rates && d.shipping_rates.length) {
                localStorage.setItem(
                  "cepCache_" + zip + "_" + variantId,
                  JSON.stringify({
                    rates: d.shipping_rates,
                    city: city,
                    state: state,
                    expires: Date.now() + 300,
                  })
                );
                showRates(d.shipping_rates, city, state, "product");
                showDelivery(zip);
                resetCartCookie();
              } else {
                if (attempts <= 3) {
                  getRates(variantId, country, state, city, zip);
                } else {
                  showRates(false, false, false, "product");
                  showDelivery(zip);
                  resetCartCookie();
                }
              }
            },
            error: function () {
              resetCartCookie();
              calcError(
                "Ocorreu um erro durante o calculo do frete, por favor, tente novamente."
              );
            },
            dataType: "json",
          });
        })
        .catch(function (err) {
          console.error(err);
          calcError(
            "Ocorreu um erro durante o calculo do frete, por favor, tente novamente."
          );
          resetCartCookie();
        });
    };

    var getCachedValues = function () {
      var pid = $('input[name="id"]').val();
      var cepCache = localStorage.getItem("cepCache");

      if (cepCache != null) {
        $(".cep-estimate").val(cepCache).trigger("input");

        var rateCache = localStorage.getItem(
          "cepCache_" + cepCache + "_" + pid
        );

        if (rateCache != null) {
          rateCache = JSON.parse(rateCache);
          if (Date.now() >= rateCache["expires"]) {
            showRates(
              rateCache["rates"],
              rateCache["city"],
              rateCache["state"],
              "product"
            );
          }
        }
      }
    };

    getCachedValues();
  }

  function showDelivery(zip) {
    var CEPInitial = 97000001;
    var CEPFinal = 97119999;
    /*
    if (Number(zip) >= CEPInitial && Number(zip) <= CEPFinal) {
      $(".shipping-estimate .rates").prepend(
        '<div class="rate"><div class="rate__info"><span><b>Motoboy: </b></span><span><b><strong>Grátis</strong></b> em <b>1 dia</b> útil</span></div></div>'
      );
    }
  */
    /*$(".shipping-estimate .rates").prepend(
      '<div class="rate"><div class="rate__info"><b> Retire na loja: </b><span><b><strong>Grátis</strong></b> em <b>1 dia</b> útil</span></div></div>'
    );*/
  }

  function showDeliveryCart() {
    console.log("showDeliveryCart :: 02");
    var CEPInitial = 97000001;
    var CEPFinal = 97119999;
    var zip = Number($("#address_zip").val().replace(/\D/g, ""));

    if (zip >= CEPInitial && zip <= CEPFinal) {
      $(".shipping-calculator .shipping_rates").prepend(
        "<li><b>Motoboy: </b> <b>Grátis</b> em <b>1</b> dia útil</li>"
      );
    }

    /*
    $(".shipping-calculator .shipping_rates").prepend(
      "<li>Retire na loja <b>Grátis</b> em <b>1</b> dia útil</li>"
    );
    */
  }

  function priceChange() {
    var priceRegular = Number(
      $(".j_price_regular")
        .text()
        .replace("R$", "")
        .replace(".", "")
        .replace(",", ".")
    );
    var priceDiscount = (priceRegular * 5) / 100;
    var priceNew = priceRegular - priceDiscount;
    var priceFormated = priceRegular.toLocaleString("pt-br", {
      style: "currency",
      currency: "BRL",
      minimumFractionDigits: 2,
    });

    $(".j_price_discount").text(priceFormated);

    //PARCELAMENTO
    var priceInstallments = priceRegular / 10;
    var priceInstallmentsFormated = priceInstallments.toLocaleString("pt-br", {
      style: "currency",
      currency: "BRL",
      minimumFractionDigits: 2,
    });
    $(".j_price_installments").text(priceInstallmentsFormated);

    //PRICE DE

    var variant = parseInt(window.location.href.split("=")[1]);
    var priceVariantCompare = 0;
    pplr_product.variants.forEach(function (product, i) {
      if (product.id == variant) {
        priceVariantCompare = product.compare_at_price;
      }
    });

    var priceRemovedParent = String(priceVariantCompare).slice(0, -2);
    var priceNewParent = parseInt(priceRemovedParent);

    var priceFormatedParent = priceNewParent.toLocaleString("pt-br", {
      style: "currency",
      currency: "BRL",
      minimumFractionDigits: 2,
    });

    $(".j_price_strike").text(priceFormatedParent);

    //Cashback
    var priceCashback = (priceRegular * 10) / 100;
    var priceCashbackFormated = priceCashback.toLocaleString("pt-br", {
      style: "currency",
      currency: "BRL",
      minimumFractionDigits: 2,
    });
    $(".j_price_cashback").text(priceCashbackFormated);
  }

  //PEGA
  function changeVariant(variant) {
    pplr_product.variants.forEach(function (product, i) {
      if (product.id == variant) {
        priceVariantCompare = product.compare_at_price;
      }
    });
  }
  setTimeout(function () {
    var observer = new MutationObserver(function (mutations, observer) {
      priceChange();
    });
  }, 5000);

  var input = document.querySelectorAll(
    "#template--14752141508713__mainproduct-7000484905065--select-pedras, .select-popout__list, .radio__buttons, .radio__legend__value, .form__width > input, [form='product-form-template--14752141508713__main-7000484905065'], .radio__buttons, .radio__fieldset .radio__button input:checked"
  );
  if (input) {
    console.log("CHANGE 3.7.3");
    input.forEach(function (element, i) {
      observer.observe(element, {
        subtree: true,
        attributes: true,
      });
    });
  }

  setTimeout(function () {
    $(
      ".meggnoapps_google_reviews_widget_carousel .review_widget_user_details .written_ago a span"
    ).each(function (i, e) {
      if ($(e).text().search("days ago") != -1) {
        $(e).text($(e).text().replace("days ago", "dias atrás"));
      }

      if ($(e).text().search("last month") != -1) {
        $(e).text($(e).text().replace("last month", "mês passado"));
      }

      if ($(e).text().search("months ago") != -1) {
        $(e).text($(e).text().replace("months ago", "meses atrás"));
      }
    });
  }, 12000);

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
